import { Component, Input, OnInit} from '@angular/core';
import { ArticleModel } from '../../models/article.model';
import { InvoiceModel } from '../../models/invoice.model';

@Component({
    selector   : 'my-article',
    template: require('./article.component.html'),
    styles: [require('./article.component.scss')],
})

export class ArticleComponent implements OnInit{

    @Input('article') article: ArticleModel;
    @Input('position') position:number;
    @Input('withoutBike') withoutBike:boolean = false;

    constructor() {

    }

    ngOnInit(){
        this.calculateValue();
    }

    changeFree(){
        this.article.free = !this.article.free;
        this.article.invoice.save();
        this.calculateValue();
    }

    changeType(_event){
        _event.stopPropagation();
        if (this.withoutBike){
            if (this.article.type == 0)
                this.article.type = 2;
            else if (this.article.type == 2)
                this.article.type = 0;
        } else {
            if (this.article.type == 0)
                this.article.type = 2;
            else if (this.article.type == 2)
                this.article.type = 0;
        }
        this.article.invoice.save();
    }

    calculateValue(){
        if (this.article.invoice instanceof InvoiceModel)
            this.article.invoice.calculateValue();
    }

    delete(){
        this.article.invoice.articles.splice(this.position - 1, 1);
        this.article.invoice.save();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/article/article.component.ts